"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BASE_API_PATH = void 0;
var _window$GLOBAL_INFO$p = window.GLOBAL_INFO.pathPrefix,
  pathPrefix = _window$GLOBAL_INFO$p === void 0 ? '' : _window$GLOBAL_INFO$p;
var MICRO_APP_ORIGIN = window.__MICRO_APP_ENVIRONMENT__ && window.__MICRO_APP_PUBLIC_PATH__ ? new URL(window.__MICRO_APP_PUBLIC_PATH__).origin || '' : '';
var BASE_API_PATH = "".concat(MICRO_APP_ORIGIN).concat(pathPrefix, "/api/xy/common");
exports.BASE_API_PATH = BASE_API_PATH;